import { Injectable, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from 'src/app/services/config.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LangService {

  private localStorageLanguageKey = 'selectedLanguage'
  public currentLanguage: string = ''

  constructor(private translateService: TranslateService,
              private configService: ConfigService) { }

  
  initializeLang(): void {

    if(localStorage.getItem('lang')){
        this.setLanguage(localStorage.getItem('lang')!,false)      
    }else{     
      if(navigator.language){   
        const navigatorLang = navigator.language.substring(0, 2) 
        this.setLanguage(navigatorLang,false)  
      } else {
        if(this.configService.companyConfig.language.default){
          this.setLanguage(this.configService.companyConfig.language.default,false)
        }
      }
    }

  }

  //Se establece el idioma recibido por parámetro y Se actualiza la info del local storage
  setLanguage(language: string, reload: boolean = true) {
    this.translateService.use(language)
    this.currentLanguage = language
    localStorage.setItem('lang',language)

    if (reload) {
      window.location.reload();
    }
  }

  //Si el idioma no está establecido se recupera del local y se retorna el valor
  getLanguage(): string {
    if (!this.currentLanguage) {
      if (localStorage.getItem('lang')) {
        this.currentLanguage = localStorage.getItem('lang')!
      }
    }
    return this.currentLanguage;
  }

}


